import cn from 'classnames';
import bank from '@shared/assets/images/bank.png';
import { usePromocode, usePromocodeForm } from './model';
import * as st from './styles.module.scss';

export const Promo = () => {
  const { methods } = usePromocodeForm();
  const { status, apply, setCode } = usePromocode();

  const {
    register,
    handleSubmit,
    formState: { isValid, isLoading, errors },
  } = methods;

  return (
    <div className={st.promo}>
      <form onSubmit={handleSubmit(apply)} className={st.row}>
        <div className={cn(st.wrapper, status === 'error' && st.error)}>
          {/* <label htmlFor="promo">Промокод</label> */}
          <input
            {...register('promo', {
              required: true,
              // minLength: { message: 'Код не может быть короче пяти символов', value: 5 },
            })}
            id="promo"
            type="text"
            autoComplete="off"
            placeholder="Введите промокод"
            disabled={status === 'loading'}
            onBlur={(e) => setCode(e.target.value)}
          />
          {errors.promo && <p className={st.error}>{errors.promo.message}</p>}
        </div>

        <button
          type="button"
          className={st.promo__apply}
          disabled={status === 'loading' || !isValid || isLoading}
          onClick={handleSubmit(apply)}
        >
          Применить
        </button>
      </form>
      <img className={st.banksLogo} src={bank} alt="" />
    </div>
  );
};
